import { render, staticRenderFns } from "./collect_points.vue?vue&type=template&id=420b31da&"
import script from "./collect_points.vue?vue&type=script&lang=js&"
export * from "./collect_points.vue?vue&type=script&lang=js&"
import style0 from "./collect_points.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports